export enum LoaderVariant {
    Horizontal = "horizontal",
    Spinner = "spinner"
}
